var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16H28",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3421 1H11.6579C10.873 1 10.2368 1.67157 10.2368 2.5V8.5C10.2368 9.32845 10.873 10 11.6579 10H17.3421C18.1269 10 18.7631 9.32845 18.7631 8.5V2.5C18.7631 1.67157 18.1269 1 17.3421 1Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81583 22H3.13162C2.3468 22 1.71057 22.6716 1.71057 23.5V29.5C1.71057 30.3285 2.3468 31 3.13162 31H8.81583C9.60068 31 10.2369 30.3285 10.2369 29.5V23.5C10.2369 22.6716 9.60068 22 8.81583 22Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8684 22H20.1842C19.3994 22 18.7632 22.6716 18.7632 23.5V29.5C18.7632 30.3285 19.3994 31 20.1842 31H25.8684C26.6533 31 27.2895 30.3285 27.2895 29.5V23.5C27.2895 22.6716 26.6533 22 25.8684 22Z",
    fill: "transparent",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16V10",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0264 22V16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97363 22V16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileConnection);
export default __webpack_public_path__ + "static/media/profile-connection.395bf90a58f2a3ca4f854b71be6cdb23.svg";
export { ForwardRef as ReactComponent };